import styled from 'styled-components';


export const Div = styled.div`
    width: 800px;
    height: 600px;
`